import accordionFaq from './components/accordion-faq'
import accordionFaqHome from './components/accordion-faq-home'
import alertNews from './components/alert-news'
import backgroundBanner from './components/background-banner'
import carousel from './components/carousel'
import cityBtnModal from './components/city-btn-modal'
import common from './components/common'
import geolocation from './components/geolocation'
import geolocationInstructionsModal from './components/geolocation-instructions-modal'
import headerInfoBar from './components/header-info-bar'
import locationsModal from './components/locations-modal'
import modal from './components/modal'
import sidebar from './components/sidebar'
import user from './components/user'
import './monkey-patch'

const onReady = async () => {
  try {
    cityBtnModal.init()
    sidebar.init()
    alertNews.getNewestAlert()
    alertNews.closeAlert()
    backgroundBanner.renderBackgroundBanner()
    carousel.initCarousel()
    common.autocompleteSearchV2()
    common.viewData()
    common.setAlertStyle()
    common.onScroll()
    common.controlMobileSearch()
    common.closeBanner()
    common.backToTopButton()
    common.initMetrics()
    common.fallbackImage()
    common.userLocationStepByStep()
    locationsModal.init()
    geolocationInstructionsModal.init()
    headerInfoBar.init()
    locationsModal.init()
    geolocationInstructionsModal.init()

    await geolocation.userGeolocation()

    modal.controlModal()
    user.userInfo()
    user.controlLoggedMenu()
    user.controlFavoritesLocalesBreadcrumb()
    accordionFaq.handleAnswerOpening()
    accordionFaqHome.handleAnswerOpening()

  } catch (e) {
    console.error('Erro ao carregar aplicação:', e)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onReady);
} else {
  onReady();
}
